export default __webpack_public_path__ + "static/plassering-4a1a02eba2e801f5f5e1dfc525d9d80a.png";